import React, { useState } from "react";
import axios from "axios";
import "./style.css"; // Optional, for custom styles

const AddNewCourse = () => {
  const [formData, setFormData] = useState({
    CourseID: "",
    CourseName: "",
    Hours: "",
    Pass: ""
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    const { CourseID, CourseName, Hours, Pass } = formData;

    // Basic validation
    if (!CourseID || !CourseName || !Hours || !Pass) {
      setError("All fields are required: CourseID, CourseName, Hours, and Pass.");
      setLoading(false);
      return;
    }

    try {
      const res = await axios.post(
        "https://elearn-api.onrender.com/api/insertCourse",
        formData
      );
      setSuccess("Course added successfully!");
      setFormData({ CourseID: "", CourseName: "", Hours: "", Pass: "" });
    } catch (err) {
      console.error(err);
      setError("Failed to insert course.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-course-container">
      <h2>Add New Course</h2>

      {error && <p className="message error">{error}</p>}
      {success && <p className="message success">{success}</p>}

      <form className="add-course-form" onSubmit={handleSubmit}>
        <div className="form-group-course">
          <label htmlFor="CourseID">Course ID</label>
          <input
            type="text"
            id="CourseID"
            name="CourseID"
            value={formData.CourseID}
            onChange={handleChange}
            placeholder="Enter Course ID"
          />
        </div>

        <div className="form-group-course">
          <label htmlFor="CourseName">Course Name</label>
          <input
            type="text"
            id="CourseName"
            name="CourseName"
            value={formData.CourseName}
            onChange={handleChange}
            placeholder="Enter Course Name"
          />
        </div>

        <div className="form-group-course">
          <label htmlFor="Hours">Hours</label>
          <input
            type="text"
            id="Hours"
            name="Hours"
            value={formData.Hours}
            onChange={handleChange}
            placeholder="Enter Hours"
          />
        </div>

        <div className="form-group-course">
          <label htmlFor="Pass">Pass</label>
          <input
            type="text"
            id="Pass"
            name="Pass"
            value={formData.Pass}
            onChange={handleChange}
            placeholder="Enter Pass Mark "
          />
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Insert Course"}
        </button>
      </form>
    </div>
  );
};

export default AddNewCourse;
